import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useReportHistory } from "../../hooks/reports/use-report-history";
import {
  ReportHistorySummary,
  ContactBreakdownTable,
  ReportHistoryTable,
} from "../../components/reports";

export function ReportHistory() {
  const [contactFilter, setContactFilter] = useState<string | null>(null);
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useReportHistory({
      contactId: contactFilter,
    });

  const handleContactClick = (contactId: string) => {
    setContactFilter(contactId === contactFilter ? null : contactId || null);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5" fontWeight={700} color="text.primary">
          Report History
        </Typography>
      </Box>

      {/* Summary Cards */}
      <ReportHistorySummary summary={data?.summary} loading={isLoading} />

      {/* Per-Contact Breakdown */}
      <ContactBreakdownTable
        data={data?.perContact}
        loading={isLoading}
        onContactClick={handleContactClick}
        selectedContactId={contactFilter}
      />

      {/* Report List */}
      <ReportHistoryTable
        reports={data?.reports}
        loading={isLoading || isFetchingNextPage}
        onLoadMore={() => fetchNextPage()}
        hasMore={hasNextPage}
      />
    </Box>
  );
}
